const columns = [
    { name: 'nome', label: 'Nome', field: 'nome', align: 'center', sortable: true },
   // { name: 'sobrenome',  label: 'Sobrenome', field: 'sobrenome', align: 'center', sortable: true },
    { name: 'email', label: 'Email', field: 'email', align: 'center', sortable: true },
    { name: 'cpf', label: 'CPF', field: 'cpf', align: 'center', sortable: true },
    { name: 'action', label: 'Action', field: 'action', align: 'center', }
]

export default columns;